export enum Sort {
  AlphabeticalAscending = 'a-z',
  AlphabeticalDescending = 'z-a',
  Newest = 'newest',
  Oldest = 'oldest',
}
